import { DateTimePicker } from '@shoflo/polymer/components/DateTimePicker/DateTimePicker';
import { handleFilterTime } from '../helper/Form.helper';
import Tooltip from '../../Tooltip';
import { StyledErrorSpan } from '../Form.styled';
import React from 'react';
import PropTypes from 'prop-types';

export const EndDateTimePickerWithToolTip = ({
  broadcast,
  endDateTime,
  dateFormat,
  handleEndDateChange,
  use12Hours,
  startDateTime,
  minEndDate,
  maxEndDate,
  setShowEndDateError,
  showEndDateError,
}) => {
  return (
    <>
      <DateTimePicker
        value={endDateTime}
        dateFormat={dateFormat}
        id="broadcastEndDateTime"
        dataTestId="endDateTimeInput"
        onChange={handleEndDateChange}
        use12Hours={use12Hours}
        disabled={!startDateTime}
        minDate={minEndDate}
        maxDate={maxEndDate}
        filterTimeFlag={true}
        filterTime={(time) =>
          handleFilterTime(time, minEndDate, maxEndDate, endDateTime)
        }
        onChangeRaw={(e) => {
          e.preventDefault();
        }}
        ariaDescribedBy="tip-broadcast-form-end-date-time-input"
        onBlur={() => {
          if (!endDateTime) {
            setShowEndDateError(true);
          }
        }}
        className={
          showEndDateError ? 'is-invalid form-control' : 'form-control'
        }
        ariaLabelledBy="endDateTimeLabel"
      />
      {!startDateTime && (
        <Tooltip
          id="broadcast-form-end-date-time-input"
          title="You must select a start date time in order to enable this field"
          placement="top"
        />
      )}
      {showEndDateError && (
        <StyledErrorSpan>
          {broadcast
            ? 'Uh oh! An end date and time must be selected if you select a start.'
            : 'Uh oh! Please select the end date.'}
        </StyledErrorSpan>
      )}
    </>
  );
};

EndDateTimePickerWithToolTip.propTypes = {
  broadcast: PropTypes.object,
  use12Hours: PropTypes.bool.isRequired,
  showEndDateError: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  endDateTime: PropTypes.instanceOf(Date),
  startDateTime: PropTypes.instanceOf(Date),
  minEndDate: PropTypes.instanceOf(Date),
  maxEndDate: PropTypes.instanceOf(Date),
  handleEndDateChange: PropTypes.func.isRequired,
  setShowEndDateError: PropTypes.func.isRequired,
};
